export default __webpack_public_path__ + "static/media/RandyHattab_Resume.5a00472f.pdf";